/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { PrimaryButton } from "../../StyledCss/styledbtn";
import formatDate from "../../util/formatdate";
import { convertKeysToCamelCase } from "../../util/convertCamelCase";
import ExpenditureHistory from "../ExpenditureHistory";
import Header from "../Header";
import LeftNavBar from "../LeftNavBar";
import SlidingModal from "../SlidingModal/slidingModal";

import FileDownloader from "../ZipFilesDownloader";
import "./index.css";

import { PageHeaderName } from "../../StyledCss/styledComponents";
import {
  getExpenditures,
  getExpenditureBillUrls,exportExpenditures
} from "../../api/services/hroneApi";
import ExpenditureForm from "../ExpenditureForm/expenditureForm";
import FailureView from "../FailureView";
import LoadingView from "../LoadingView";
import PageHeader from "../PageHeader";
import { usePermissions } from "../../redux/slices/permissionsSlice";
import { FEATURE_CODES } from "../../util/featureCodes";

const apiStatusConstants = {
  initial: "INITIAL",
  success: "SUCCESS",
  failure: "FAILURE",
  inProgress: "IN_PROGRESS",
};

const Expenditure = () => {
  const { hasPermission } = usePermissions();
  const canCreateExpenditure = hasPermission(FEATURE_CODES.EXPENDITURE_CREATE);
  const canExportExpenditures = hasPermission(FEATURE_CODES.EXPENDITURE_EXPORT);
  const canDownloadBills = hasPermission(FEATURE_CODES.EXPENDITURE_BILL_DOWNLOAD);
  const date = new Date();
  const [startMonth, setStartMonth] = useState(date);
  const [endMonth, setEndMonth] = useState(date);
  const [expenditureHistoryList, setExpenditureHistory] = useState([]);
  const formattedStartMonth = format(startMonth, "yyyy-MM");
  const [uploadBillModal, setUploadBillModal] = useState(false);
  const [monthlyBills, setMonthlyBills] = useState();
  const [apiStatus, setApiStatus] = useState(apiStatusConstants.initial);
   const [loadingStates, setLoadingStates] = useState({
    exportExpenditures: false,
  });

  const setLoading = (operation, isLoading) => {
    setLoadingStates((prev) => ({ ...prev, [operation]: isLoading }));
  };

  useEffect(() => {
    getExpenditureHistory();
  }, [startMonth, endMonth]);

  useEffect(() => {
    if (canDownloadBills) {
      getMonthlyBills();
    }
  }, [startMonth, endMonth, canDownloadBills]);

  const getExpenditureHistory = async () => {
    setApiStatus(apiStatusConstants.inProgress);
    try {
      
      const response = await getExpenditures({
        start_month: format(startMonth, "yyyy-MM"),
        end_month: format(endMonth, "yyyy-MM"),
      });
      if (response.status === 200) {
        setApiStatus(apiStatusConstants.success);
        const data = convertKeysToCamelCase(await response.json());
        const updatedData = data.map((eachItem) => ({
          ...eachItem,
          date: formatDate(eachItem.date),
        }));
        setExpenditureHistory(updatedData);
      } else {
        setApiStatus(apiStatusConstants.failure);
      }
    } catch (error) {
      // alert(error);
      setApiStatus(apiStatusConstants.failure);
    }
  };

  const getMonthlyBills = async () => {
    try {
      const response = await getExpenditureBillUrls({
        start_month: format(startMonth, "yyyy-MM"),
        end_month: format(endMonth, "yyyy-MM"),
      });
      if (response.status === 200) {
        const data = await response.json();
        setMonthlyBills(data);
      }
    } catch (error) { }
  };
  const onCloseModal = () => {
    setUploadBillModal(false);
  };
  const refreshData = () => getExpenditureHistory();

  const handleExport = async () => {
    try {
      setLoading("exportExpenditures", true);

      const response = await exportExpenditures({
        start_month: format(startMonth, "yyyy-MM"),
        end_month: format(endMonth, "yyyy-MM"),
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `expenditures_${format(startMonth, "yyyy-MM")}_${format(endMonth, "yyyy-MM")}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
    }
    finally{
            setLoading("exportExpenditures", false);

    }
  };

  const renderExpenditureTable = () => {
    switch (apiStatus) {
      case apiStatusConstants.success:
        return (
          <ExpenditureHistory
            expenditureHistoryList={expenditureHistoryList}
            refreshData={refreshData}
            canDownloadBills={canDownloadBills}
          />
        );
      case apiStatusConstants.failure:
        return <FailureView onClickRetry={refreshData} />;
      case apiStatusConstants.inProgress:
        return <LoadingView />;
      default:
        return null;
    }
  };

  return (
    <div>
      <Header />
      <div className="d-flex ">
        <LeftNavBar />
        <div className="page-content-wrapper">
          <PageHeader>
            <PageHeaderName>Expenditure</PageHeaderName>

            <div className="d-flex align-items-center">
              {canCreateExpenditure && (
                <PrimaryButton
                  style={{ marginRight: "10px" }}
                  onClick={() => setUploadBillModal(!uploadBillModal)}
                >
                  Upload Bill
                </PrimaryButton>
              )}
              {canDownloadBills && (
                <FileDownloader links={monthlyBills} date={formattedStartMonth} />
              )}
              {canExportExpenditures && (
                <PrimaryButton onClick={handleExport}>
                  {loadingStates.exportExpenditures ? "Exporting..." : "Export"}
                </PrimaryButton>
              )}
            </div>
          </PageHeader>
    
          <div className="table-container">
                 <div className="d-flex flex-row flex-wrap justify-content-end gap-2 m-2">
        <div className="month-picker ">
          <label className="mb-1">Start Month</label>
          <DatePicker
            selected={startMonth}
            onChange={(date) => {
              if (date) {
                setStartMonth(date);
                if (date > endMonth) {
                            setEndMonth(date);
                          }
              } else {
                setStartMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            className="date-input-label"
          />
        </div>
        <div className="month-picker ">
          <label className="mb-1">End Month</label>
          <DatePicker
            selected={endMonth}
            onChange={(date) => {
              if (date) {
                setEndMonth(date);
              } else {
                setEndMonth(new Date());
              }
            }}
            showMonthYearPicker
            dateFormat="MMMM yyyy"
            className="date-input-label"
            minDate={startMonth}

          />
        </div>
        </div>
        {renderExpenditureTable()}</div>
          <SlidingModal
            modalName="Add Expenditure"
            closeBtn={onCloseModal}
            isModalOpen={uploadBillModal}
          >
            <ExpenditureForm
              getExpenditureHistory={getExpenditureHistory}
              setUploadBillModal={setUploadBillModal}
            />
          </SlidingModal>

        </div>
      </div>
    </div>
  );
};

export default Expenditure;
